import { Module } from 'vuex';
import { RootState } from '@/store/state';
import actions from '@/store/modules/order/actions';
import mutations from '@/store/modules/order/mutations';
import state, { OrderState } from '@/store/modules/order/state';

const CartModule: Module<OrderState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default CartModule;
